import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './InReviewCard.module.css';
const InReviewCard = ({ keyID = 'inReviewCard' }) => {
  return <div className={css.reviewBatch} key={keyID} ><FormattedMessage id='Circle.inReview'/></div>;
};

export default InReviewCard;
